export default "__VITE_PUBLIC_ASSET__64a14c4b__"